/**
 * When it is safe to re-read the Work board behind the client's back.
 *
 * The board is read-only (spec 2026-10-28, "Client Work view shows the portal
 * lifecycle read-only"): dispatch, an editor's own actions and the gate move a
 * work item along even while nobody is looking, so a timer re-reads `/api/work`
 * the same way the old Trello-backed board re-read Trello. The one thing worth
 * protecting is an open card panel - re-grouping the columns out from under a
 * client mid-read would close or relocate the very card they opened.
 *
 * The decision is a pure function so the cases can be asserted without a
 * browser.
 *
 * WHEN the check runs is the screen's business: the interval, plus
 * `visibilitychange` AND `window.focus` (neither covers the other - a brand
 * with another app in front keeps the tab visible but not focused).
 *
 * @module web/screens/app/board/refresh
 */

/** How long between re-reads. */
export const REFRESH_MS = 10_000;

export interface RefreshConditions {
  /** Tab in the foreground. A background tab re-reading is wasted work. */
  visible: boolean;
  /** The board has loaded once. Refreshing over a skeleton or an error is noise. */
  ready: boolean;
  /** The card panel is open. */
  panelOpen: boolean;
}

export function shouldAutoRefresh(c: RefreshConditions): boolean {
  if (!c.visible || !c.ready) return false;
  if (c.panelOpen) return false;
  return true;
}
